import { ActionReducer, INIT, UPDATE, MetaReducer } from '@ngrx/store';
import { CryptoService } from './crypto.service';

const STORAGE_KEY = 'AlphaOneStore';

export function storeStorageMetaReducer(cryptoService: CryptoService): MetaReducer<any> {
  return (reducer: ActionReducer<any>) => {
    return (state, action) => {
      const isBrowser = typeof window !== 'undefined' && typeof localStorage !== 'undefined';

      // ✅ Restore only once on INIT / UPDATE
      if (isBrowser && (action.type === INIT || action.type === UPDATE)) {
        const encrypted = localStorage.getItem(STORAGE_KEY);

        if (encrypted) {
          try {
            return cryptoService.decrypt(encrypted);
          } catch (e) {
            console.error('Decrypt failed. Clearing invalid storage.', e);
            localStorage.removeItem(STORAGE_KEY);
          }
        }
      }

      const nextState = reducer(state, action);

      // ✅ Persist each change
      if (isBrowser) {
        try {
          const encrypted = cryptoService.encrypt(nextState);
          localStorage.setItem(STORAGE_KEY, encrypted);
        } catch (e) {
          console.error('Encrypt/Save failed:', e);
        }
      }

      return nextState;
    };
  };
}
